export const LOGIN = "LOGIN";
export const loggedinUserAction = (data) => {
    return {
        type: LOGIN,
        payload:data
    }
}